module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col h-full overflow-hidden"
  }, [_vm._m(0), _vm._v(" "), _c('main', {
    staticClass: "flex-col overflow-y-auto px-3",
    class: _vm.isFullscreen ? 'height-list-fullscreen' : 'height-list'
  }, [_c('div', {
    staticClass: "bg-white text-lg"
  }, [(_vm.visible_guidances.length) ? _c('div', _vm._l((_vm.toggleable_guiding_questions), function(question, index) {
    return (question.is_active) ? _c('div', {
      key: index + 1,
      staticClass: "mt-2 p-2"
    }, [_vm._v("\n          " + _vm._s(index + 1) + ". " + _vm._s(question.question) + "\n        ")]) : _vm._e()
  }), 0) : _c('div', [_c('div', {
    staticClass: "mt-2 p-2"
  }, [_vm._v("No Guiding Questions created or activated")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "border-b border-slate-300"
  }, [_c('p', {
    staticClass: "font-semibold text-base pt-4 pb-3 px-3"
  }, [_vm._v("\n        Discussion Questions\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-152b79de!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/discussionQuestionsSecondScreen.vue
// module id = 1853
// module chunks = 61